<template>
    <div class="internal-workbench">
        <van-nav-bar title="内部工作台" left-arrow @click-left="$router.back()" />
        <main class="workbench-content">
            <section class="hero-card">
                <div>
                    <span class="eyebrow">INTERNAL WORKBENCH</span>
                    <h1>内部工作台</h1>
                    <p>售后处理与仓库作业统一入口</p>
                </div>
                <van-icon name="apps-o" size="52" />
            </section>

            <section class="summary-card">
                <div class="summary_head">
                    <span class="summary_wh">{{summary.currentStockName || '未选择仓库'}}</span>
                    <span class="summary_tip" v-if="loading">统计中…</span>
                </div>
                <div class="summary_grid">
                    <div class="summary_cell" @click="go('/warehouse/product')">
                        <span class="cell_num">{{num(summary.productTotal)}}</span>
                        <span class="cell_label">产品</span>
                    </div>
                    <div class="summary_cell" v-if="canViewMaterial" @click="go('/warehouse/material')">
                        <span class="cell_num green">{{num(summary.materialTotal)}}</span>
                        <span class="cell_label">物料</span>
                    </div>
                    <div class="summary_cell" @click="go('/warehouse/shipment')">
                        <span class="cell_num red">{{num(summary.pendingShipmentCount)}}</span>
                        <span class="cell_label">待发货</span>
                    </div>
                </div>
            </section>

            <section class="module-section">
                <div class="section-title"><strong>售后处理</strong><span>设备接收、维修和寄送</span></div>
                <div class="module-grid">
                    <button type="button" class="module-card blue" @click="go('/after-sales/mobile')"><span class="module-icon"><van-icon name="scan" /></span><strong>售后接件</strong><small>扫码建档、生成内部 SN</small></button>
                    <button type="button" class="module-card purple" @click="go('/after-sales/orders')"><span class="module-icon"><van-icon name="orders-o" /></span><strong>售后工单</strong><small>查看并继续处理历史工单</small></button>
                </div>
            </section>

            <section class="module-section">
                <div class="section-title"><strong>仓库作业</strong><span>库存、出入库和发货</span></div>
                <div class="module-grid">
                    <button type="button" class="module-card green" @click="go('/warehouse')"><span class="module-icon"><van-icon name="home-o" /></span><strong>仓库总览</strong><small>查看仓库和设备状态</small></button>
                    <button type="button" class="module-card orange" @click="go('/warehouse/product')"><span class="module-icon"><van-icon name="shop-o" /></span><strong>产品库存</strong><small>管理产品及库存数量</small></button>
                    <button v-if="canViewMaterial" type="button" class="module-card teal" @click="go('/warehouse/material')"><span class="module-icon"><van-icon name="apps-o" /></span><strong>物料库存</strong><small>管理维修物料和配件</small></button>
                    <button type="button" class="module-card red" @click="go('/warehouse/shipment')"><span class="module-icon"><van-icon name="logistics" /></span><strong>发货记录</strong><small>查看和处理仓库发货</small></button>
                </div>
            </section>

            <van-notice-bar left-icon="info-o" text="售后和仓库模块会根据你的仓库角色限制可操作范围" />
        </main>
        <footer-main active="/internal/workbench"></footer-main>
    </div>
</template>

<script>
import footerMain from '@/components/footer.vue'
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import { fetchWorkbenchSummary } from '@/utils/workbenchSummary'

export default {
    name: 'InternalWorkbench',
    components: { footerMain },
    data() {
        return {
            loading: false,
            summary: {
                currentStockName: '',
                productTotal: null,
                materialTotal: null,
                pendingShipmentCount: null
            }
        }
    },
    computed: {
        userInfo() { return this.$root.userInfo || {} },
        isSuper() { return this.$root.isSuperRoot === true },
        canViewMaterial() { return this.isSuper || Number(this.userInfo.stock_user_view_power) !== 1 }
    },
    mounted() {
        document.title = '内部工作台'
        this.loadSummary()
    },
    methods: {
        go(path) { this.$router.push(path) },
        // null 表示"没取到"，要显示 '-' 而不是 0 —— 0 会让人以为真的没有待发货
        num(value) {
            return (value === null || value === undefined) ? '-' : value
        },
        async loadSummary() {
            this.loading = true
            try {
                const res = await fetchWorkbenchSummary(studio_api, this.$root.app_id, {
                    withMaterial: this.canViewMaterial
                })
                this.summary = res
            } catch (e) {
                // 概览取不到就保持 '-'，不弹错：下面的功能入口照常能用
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.internal-workbench { width: 100%; height: 100%; min-height: 0; overflow-x: hidden; overflow-y: auto; -webkit-overflow-scrolling: touch; overscroll-behavior-y: contain; background: #f5f8fb; color: #1f2937; }
/* 底部有主菜单（98px + 安全区），内容要让开，否则最后一屏点不到 */
.workbench-content { max-width: 760px; margin: 0 auto; padding: 16px 16px 150px; }
.hero-card { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 24px 22px; border-radius: 20px; color: #fff; background: linear-gradient(135deg, #315fe8, #6a82ed); box-shadow: 0 12px 26px rgba(49,95,232,.2); }
.eyebrow { display: block; font-size: 14px; letter-spacing: 1.5px; opacity: .8; }
.hero-card h1 { margin: 9px 0 6px; font-size: 32px; }
.hero-card p { margin: 0; opacity: .88; font-size: 16px; }
.summary-card { margin-top: 14px; padding: 16px 18px; border-radius: 16px; background: #fff; box-shadow: 0 5px 18px rgba(31,41,55,.06); }
.summary_head { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 12px; }
.summary_wh { font-size: 17px; font-weight: 600; color: #1f2937; }
.summary_tip { font-size: 14px; color: #94a3b8; }
.summary_grid { display: flex; align-items: stretch; }
.summary_cell { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 6px 0; -webkit-tap-highlight-color: transparent; }
.summary_cell:active { opacity: .6; }
.cell_num { font-size: 30px; font-weight: 700; line-height: 1.1; color: #315fe8; }
.cell_num.green { color: #2ca873; }
.cell_num.red { color: #e66b70; }
.cell_label { font-size: 15px; color: #64748b; }
.module-section { margin-top: 22px; }
.section-title { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.section-title strong { font-size: 21px; }
.section-title span { color: #94a3b8; font-size: 14px; }
.module-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.module-card { min-height: 150px; padding: 18px; border: 0; border-radius: 16px; text-align: left; color: #1e293b; background: #fff; box-shadow: 0 5px 18px rgba(31,41,55,.06); }
.module-card strong, .module-card small { display: block; }
.module-card strong { margin-top: 13px; font-size: 19px; }
.module-card small { margin-top: 7px; color: #64748b; line-height: 1.5; font-size: 15px; }
.module-icon { display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; border-radius: 13px; color: #fff; font-size: 25px; }
.blue .module-icon { background: #4f76ef; }.purple .module-icon { background: #8b6ce8; }.green .module-icon { background: #2ca873; }.orange .module-icon { background: #ed9b43; }.teal .module-icon { background: #2aa8a2; }.red .module-icon { background: #e66b70; }
.internal-workbench .van-notice-bar { margin-top: 22px; border-radius: 10px; }
.internal-workbench ::v-deep .van-nav-bar__title { font-size: 22px; font-weight: 600; }
.internal-workbench ::v-deep .van-nav-bar__arrow { font-size: 25px; }
.internal-workbench ::v-deep .van-notice-bar__content { font-size: 17px; }
@media (max-width: 360px) { .module-grid { grid-template-columns: 1fr; } }
</style>
